import { useState, useEffect } from "react";
// import { useAuth } from "../context/AuthContext";
import { wishlistService } from "../services/wishlistService";
import { useNavigate } from "react-router-dom";
import ProductCard from "../components/ProductCard";
import { useTheme } from "../context/ThemeContext";

export default function WishlistPage() {
  // COMMENTED: Login requirement disabled for regular users
  // const { user } = useAuth();
  const navigate = useNavigate();
  const { darkMode } = useTheme();
  
  const [wishlistItems, setWishlistItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [products, setProducts] = useState([]);

  // Generate a simple user ID for localStorage if not logged in
  const getUserId = () => {
    // For admin use, you can uncomment the auth check
    // const { user } = useAuth();
    // if (user) return user.uid;
    
    // For regular users, use a fixed localStorage ID
    let userId = localStorage.getItem('anonymous_user_id');
    if (!userId) {
      userId = 'user_' + Date.now();
      localStorage.setItem('anonymous_user_id', userId);
    }
    return userId;
  };

  useEffect(() => {
    // COMMENTED: Login requirement disabled
    // if (!user) {
    //   navigate("/login");
    //   return;
    // }

    const loadData = async () => {
      await fetchWishlist();
      await fetchProducts();
    };
    
    loadData();
  }, [/* user, */ navigate]);

  const fetchProducts = async () => {
    try {

      const response = await fetch(`${import.meta.env.VITE_API_BASE_URL}/products/all`);

      if (response.ok) {
        const data = await response.json();
        setProducts(data);
      }
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  const fetchWishlist = async () => {
    try {
      setLoading(true);
      const userId = getUserId();
      const items = await wishlistService.getWishlist(userId);
      
      // Filter out items with invalid product IDs
      const validItems = items.filter(item => item.productId && item.productId !== 'undefined' && item.productId !== '');
      
      setWishlistItems(validItems);
      setError(null);
    } catch (err) {
      console.error("Error fetching wishlist:", err);
      setError("Failed to load wishlist. Please try again.");
      setWishlistItems([]);
    } finally {
      setLoading(false);
    }
  };

  // Listen for wishlist updates
  useEffect(() => {
    const handleWishlistUpdate = async () => {
      await fetchWishlist();
    };

    window.addEventListener("wishlist-updated", handleWishlistUpdate);
    return () => {
      window.removeEventListener("wishlist-updated", handleWishlistUpdate);
    };
  }, []);

  // Get product data for wishlist items
  const getWishlistProductData = (productId) => {
    const product = products.find(p => p.id === productId);
    if (product) {
      return {
        id: product.id,
        title: product.title,
        price: `₹${product.price}`,
        image: product.image,
        affiliateLink: product.affiliateLink,
        platform: product.platform,
        rating: product.rating,
        category: product.category,
        dealEndTime: product.dealEndTime
      };
    }
    
    // Fallback
    return {
      id: productId,
      title: 'Product Not Found',
      price: '₹0',
      image: '/placeholder.png',
      affiliateLink: '#',
      platform: 'Amazon',
      rating: 0,
      category: 'General',
      dealEndTime: null
    };
  };

  if (loading) {
    return (
      <div className={`wishlist-page ${darkMode ? "dark" : ""}`}>
        <div className="container">
          <h1>My Wishlist</h1>
          <p>Loading your wishlist...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={`wishlist-page ${darkMode ? "dark" : ""}`}>
        <div className="container">
          <h1>My Wishlist</h1>
          <p className="error">{error}</p>
          <button onClick={fetchWishlist} className="retry-btn">
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (wishlistItems.length === 0) {
    return (
      <div className={`wishlist-page ${darkMode ? "dark" : ""}`}>
        <div className="container">
          <h1>My Wishlist</h1>
          <div className="empty-wishlist">
            <p>Your wishlist is empty!</p>
            <button onClick={() => navigate("/")} className="continue-shopping-btn">
              Continue Shopping
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`wishlist-page ${darkMode ? "dark" : ""}`}>
      <div className="container">
        <h1>My Wishlist</h1>
        <p className="wishlist-count">
          You have {wishlistItems.length} item{wishlistItems.length !== 1 ? "s" : ""} in your wishlist
        </p>
        
        <div className="grid">
          {wishlistItems.map((wishlistItem) => (
            <ProductCard 
              key={wishlistItem.id} 
              product={getWishlistProductData(wishlistItem.productId)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
